import { render, staticRenderFns } from "./ResumeTemp6.vue?vue&type=template&id=13229c20&scoped=true&"
import script from "./ResumeTemp6.vue?vue&type=script&lang=js&"
export * from "./ResumeTemp6.vue?vue&type=script&lang=js&"
import style0 from "./ResumeTemp6.vue?vue&type=style&index=0&id=13229c20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13229c20",
  null
  
)

export default component.exports